<div class="root" [ngClass]="[colorStyle, fontSize]" (click)="emitClick()">
  <ng-container *ngIf="iconName">
    <app-lucide-icon class="icon" [size]="26" [iconName]="iconName" [color]="iconColor"></app-lucide-icon>
  </ng-container>
  <span class="text">{{ text }}</span>
</div>
